/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import FlexEvent = Models.FlexEvent;
    import IPaginatedList = Models.IPaginatedList;
    import NetworkNode = Models.NetworkNode;
    import Block = Models.Block;
    import Vno = Application.Models.Vno;

    export class AdminEventsController {
        public static $name: string = "adminEventsController";
        public static $inject: string[] = ['alarmsService',
                                           '$window',
                                           'stompService',
                                           '$scope',
                                           '$filter',
                                           'timezoneService',
                                           '$q',
                                           'blockService',
                                           'networkNodeService',
                                           'vnoService',
                                           '$timeout'];
        public static PAGE_SIZE: number = 40;

        public componentOperations: string[] = Services.ComponentOperationService.getAvailableTypes().sort();
        public componentOperationSelected: string = 'All';

        private eventsRepo: IOffsettedRepo = {
            page: 0,
            totalLoaded: 0,
            pendingElements: 0,
            firstLoadFinished: false,
            loading: true,
        };
        private searchText: string = "";
        private nodes: { [key: string]: NetworkNode } = {};
        private blocks: { [key: string]: Block } = {};
        private vnos: { [key: number]: Vno } = {};
        private tBodyPlaceholder: JQuery = $("#events_table tbody");
        private fromDatePlaceholder: JQuery = $('#from-date-picker');
        private toDatePlaceholder: JQuery = $('#to-date-picker');
        private fromDatePicker: UIkit.DatePicker;
        private toDatePicker: UIkit.DatePicker;
        private dateFrom: string;
        private dateTo: string;
        private timeFrom: string;
        private timeTo: string;
        private startDate: Date;
        private endDate: Date;

        constructor(private alarmsService: Services.AlarmsService,
                    private $window: ng.IWindowService,
                    stompService: Services.StompService,
                    private $scope: ng.IScope,
                    private $filter: Filters.ICustomFilters,
                    private timezoneService: Services.TimezoneService,
                    private $q: ng.IQService,
                    private blockService: Services.BlockService,
                    private networkNodeService: Services.NetworkNodeService,
                    private vnoService: Services.VnoService,
                    private $timeout: ng.ITimeoutService) {
            $timeout(() => {
                window.altair_admin_common_init();
            }, 500);
            this.componentOperations.unshift('All');
            this.$q
                .all([
                    this.networkNodeService.getAllNetworkNodesPromise(),
                    this.blockService.getAllBlocksPromise(),
                    this.alarmsService.findEventsForEventBrowser(AdminEventsController.PAGE_SIZE, undefined, undefined,
                                                                 undefined, undefined, undefined, undefined),
                    this.vnoService.findAll(),
                ])
                .then((res: [NetworkNode[], Block[], IPaginatedList<FlexEvent>, Vno[]]) => {
                    // mapping nodes
                    for (let node of res[0])
                        this.nodes[Common.Utils.strIdFromHref(node.href)] = node;

                    // mapping blocks
                    for (let block of res[1])
                        this.blocks[Common.Utils.strIdFromHref(block.href)] = block;

                    for (let vno of res[3]) {
                        this.vnos[vno.id] = vno;
                    }

                    // drawing last events
                    this.eventsRepo.pendingElements = res[2].page.totalElements;
                    this.loadEvents(res[2]);
                    this.eventsRepo.firstLoadFinished = true;
                    this.eventsRepo.loading = false;

                    // drawing more events on scroll
                    this.launchScrollEvent();
                });

            this.loadDatePickers();

            this.$scope.$on('$destroy', () => {
                this.unbindEvents();
            });
        }

        public search(): void {
            this.getDatesFromPicker();
            this.eventsRepo.firstLoadFinished = false;
            this.eventsRepo.loading = true;
            this.eventsRepo.page = 0
            let co: Models.ComponentOperation =
                        Services.ComponentOperationService.getComponentOperationFromType(this.componentOperationSelected);
            this.alarmsService
                .findEventsForEventBrowser(AdminEventsController.PAGE_SIZE,
                                           !this.searchText ? undefined : this.searchText,
                                           co.component, co.operation, this.startDate, this.endDate)
                .then((events: IPaginatedList<FlexEvent>) => {
                    this.unbindEvents();
                    this.tBodyPlaceholder.empty();
                    if (events.page.totalElements === 0) {
                        this.drawNotDataFound();
                    } else {
                        this.eventsRepo.pendingElements = events.page.totalElements;
                        this.loadEvents(events);
                    }
                    this.eventsRepo.firstLoadFinished = true;
                    this.eventsRepo.loading = false;
                });
        }

        public clear(): void {
            this.searchText = "";
            this.dateFrom = undefined;
            this.dateTo = undefined;
            this.timeFrom = undefined;
            this.timeTo = undefined;
            this.componentOperationSelected = 'All';
            this.search();
        }

        private loadEvents(events: IPaginatedList<FlexEvent>): void {
            this.eventsRepo.totalLoaded = this.eventsRepo.totalLoaded + events.elements.length;
            this.eventsRepo.pendingElements = this.eventsRepo.pendingElements - events.elements.length;
            events.elements.forEach((event: FlexEvent) => {
                this.drawEvent(event);
            });
        }

        private drawEvent(event: FlexEvent): void {
            let userName: string = event.userId;
            if (event.userId === 'demiurgo') {
                userName = '<i>system<i>';
            } else if (event.userId === 'unknown') {
                userName = '<i>unknown</i>';
            }
            let idAlreadyExists: boolean = $(`#event-${event.id}-info`).length > 0 ? true : false;
            if (!idAlreadyExists) {
                let loginEvent: boolean = event.operation === Models.LOGIN_OPERATION ? true : false;
                let logoutEvent: boolean = event.operation === Models.LOGOUT_OPERATION ? true : false;
                if (!(event.userId === 'demiurgo' && (loginEvent || logoutEvent))) {
                    let newRow: string = 
                        `<tr>
                            <td>
                                ${this.$filter('timezone')(new Date(event.timestamp),
                                                           'D-MM-YYYY HH:mm:ss',
                                                           this.timezoneService.getEffectiveTimezone())}
                            </td>
                            <td>${userName}</td>
                            <td>${Services.ComponentOperationService.getTypeFromComponentOperation(event.component, event.operation)}</td>
                            <td><i id="event-${event.id}-icon" class="material-icons"></i></td>
                            <td id="event-${event.id}-info"></td>
                            <td>
                                <i id="event-${event.id}-details-button" class="event-to-unbind" data-uk-tooltip tooltip="Details"
                                class="material-icons uk-text-muted" style="cursor: pointer; display: none;">
                                    info
                                </i>
                            </td>
                        </tr>
                        <tr id="event-${event.id}-details" class="uk-text-muted" style="display: none;">
                            <td colspan="7"><pre style="max-width: 600px; float: right;" id="event-${event.id}-details-content"></td>
                        </tr>`;
                    this.tBodyPlaceholder.append(newRow);
                    this.eventDataPrettyPrint(event);
                }
            }
        }

        private drawNotDataFound(): void {
            let newRow: string =
                `<tr class="uk-text-center uk-text-muted">
                    <td colspan="7"><i>No results found</i></td>
                </tr>`;
            this.tBodyPlaceholder.append(newRow);
        }

        private launchScrollEvent(): void {
            angular.element(this.$window).bind('scroll', () => {
                if ((this.$window.innerHeight + this.$window.scrollY) >= document.body.scrollHeight) {
                    this.loadMore();
                }
            });
        }

        private loadMore(): void {
            if (this.eventsRepo.pendingElements > 0 && !this.eventsRepo.loading) {
                this.eventsRepo.loading = true;
                let co: Models.ComponentOperation =
                    Services.ComponentOperationService.getComponentOperationFromType(this.componentOperationSelected);

                this.eventsRepo.page++;

                this.alarmsService
                    .findEventsForEventBrowser(AdminEventsController.PAGE_SIZE,
                        !this.searchText ? undefined : this.searchText,
                        co.component, co.operation, this.startDate, this.endDate, this.eventsRepo.page)
                    .then((events: IPaginatedList<FlexEvent>) => {
                        this.loadEvents(events);
                        this.eventsRepo.loading = false;
                    });
            }
        }

        private getDatesFromPicker(): void {
            this.startDate = !this.dateFrom ? new Date(2015, 0, 1) : this.stringToDate(this.dateFrom, this.timeFrom);
            this.endDate = !this.dateTo ? new Date() : this.stringToDate(this.dateTo, this.timeTo);
        }

        private stringToDate(date: string, time: string): Date {
            let times: string[] = time === undefined ? [] : time.split(":");
            let hours: number = 0;
            let minutes: number = 0;
            if (time !== undefined) {
                hours = times[0] !== undefined ? Number(times[0]) : 0;
                minutes = times[1] !== undefined ? Number(times[1]) : 0;
            }
            let m: string[] = date.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
            return (m) ? new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]), hours, minutes) : undefined;
        }

        private loadDatePickers(): void {
            this.fromDatePicker = UIkit.datepicker(this.fromDatePlaceholder, {format: 'DD/MM/YYYY', maxDate: 0});
            this.toDatePicker = UIkit.datepicker(this.toDatePlaceholder, {format: 'DD/MM/YYYY', maxDate: 0});
        }

        private eventDataPrettyPrint(event: FlexEvent): void {
            let placeHolder: JQuery = $(`#event-${event.id}-info`);
            let iconPlaceHolder: JQuery = $(`#event-${event.id}-icon`);
            placeHolder.html(`<pre>${this.$filter('json')(event.data)}</pre>`);
            let eventDetailsRow: JQuery = $(`#event-${event.id}-details`);
            $(`#event-${event.id}-details-button`).bind('click', () => {
                let currentDisplayValue: string = eventDetailsRow.css('display');
                currentDisplayValue === 'none' ? eventDetailsRow.css('display', 'table-row') : eventDetailsRow.css('display', 'none');
            });

            // flexo events
            if (event.component === Models.FLEXO_COMPONENT) {
                if (event.operation === Models.TAKE_OPERATION) {
                    let sourceName: string = "Unknown";
                    let sinkName: string = "Unknown";
                    let sourceBlock: Block = this.blocks[event.data.source.toString()];
                    if (sourceBlock !== undefined) {
                        sourceName = sourceBlock.name;
                    }
                    let sinkBlock: Block = this.blocks[event.data.sink.toString()];
                    if (sinkBlock !== undefined) {
                        sinkName = sinkBlock.name;
                    }
                    placeHolder.html(`Connection made between <i>${sourceName}</i> and <i>${sinkName}</i>.`);
                    iconPlaceHolder.html('arrow_forward');
                } else if (event.operation === Models.DROP_OPERATION) {
                    let sourceName: string = "Unknown";
                    let sinkName: string = "Unknown";
                    if (event.data && event.data.source) {
                        let sourceBlock: Block = this.blocks[event.data.source.toString()];
                        if (sourceBlock !== undefined) {
                            sourceName = sourceBlock.name;
                        }
                    } else {
                        sourceName = "node " + event.data.streamPipe.sourceNodeHref;
                    }
                    let sinkBlock: Block = this.blocks[event.data.sink.toString()];
                    if (sinkBlock !== undefined) {
                        sinkName = sinkBlock.name;
                    }
                    placeHolder.html(`Connection dropped between <i>${sourceName}</i> and <i>${sinkName}</i>.`);
                    iconPlaceHolder.html('arrow_back');
                } else if (event.operation === Models.FAILED_STREAM_PIPE_OPERATION) {
                    let sourceName: string = "Unknown";
                    let sinkName: string = "Unknown";
                    let sourceBlock: Block = this.blocks[event.data.source.toString()];
                    if (sourceBlock !== undefined) {
                        sourceName = sourceBlock.name;
                    }
                    let sinkBlock: Block = this.blocks[event.data.sink.toString()];
                    if (sinkBlock !== undefined) {
                        sinkName = sinkBlock.name;
                    }
                    let reason: string = event.data.errorMessage;
                    placeHolder.html(`Connection failed between <i>${sourceName}</i> and <i>${sinkName}</i>.
                         Reason: <br> <i>${reason}</i>`);
                    iconPlaceHolder.html('gps_off').css('color', 'red');
                } else if (event.operation === Models.CONFIRM_ALARM_OPERATION) {
                    placeHolder.html(`Confirmed alarm for <i>${event.data.deviceName}</i>.<br/>
                                      Parameter: ${event.data.name}. Reason: ${event.data.reason}.<br/>
                                      Comment: ${event.data.confirmComment === '' ? 'no comment' : event.data.confirmComment}`);
                    iconPlaceHolder.html('notifications_off');
                } else if (event.operation === Models.QUICK_SETTINGS_OPERATION) {
                    let nodeName: string = "Unknown";
                    let node: NetworkNode = this.nodes[event.data.id];
                    if (node !== undefined) {
                        nodeName = node.name;
                    }
                    placeHolder.html(`<i>${nodeName}</i> settings changed from stream details view:
                                      ${event.data.optionDisplayname} set to ${event.data.valueDisplayName}.`);
                    iconPlaceHolder.html('settings');
                } else if (event.operation === Models.QUICK_SETTINGS_EXTERNALLY_OPERATION) {
                    let nodeName: string = "Unknown";
                    let node: NetworkNode = this.nodes[event.data.id];
                    if (node !== undefined) {
                        nodeName = node.name;
                    }
                    placeHolder.html(`<i>${nodeName}</i> settings changed from external interface:
                                      ${event.data.optionDisplayname} set to ${event.data.valueDisplayName}.`);
                    iconPlaceHolder.html('settings');
                } else if (event.operation === Models.QUICK_SETTINGS_REQUESTED_OPERATION) {
                    let nodeName: string = "Unknown";
                    let node: NetworkNode = this.nodes[event.data.id];
                    if (node !== undefined) {
                        nodeName = node.name;
                    }
                    placeHolder.html(`<i>${nodeName}</i> settings change requested:
                                      ${event.data.option} set to ${event.data.value}.`);
                    iconPlaceHolder.html('settings');
                } else if (event.operation === Models.LOGIN_OPERATION) {
                    placeHolder.html(`User logged in.`);
                    iconPlaceHolder.html('person');
                } else if (event.operation === Models.LOGOUT_OPERATION) {
                    placeHolder.html(`User logged out.`);
                    iconPlaceHolder.html('person');
                } else if (event.operation === Models.IMPERSONATE_OPERATION) {
                    placeHolder.html(`Impersonated <i>${event.data.username}</i> `);
                    iconPlaceHolder.html('person');
                } else if (event.operation === Models.EXIT_IMPERSONATE_OPERATION) {
                    placeHolder.html(`Finished impersonating <i>${event.data.username}</i> `);
                    iconPlaceHolder.html('person');
                } else if (event.operation === Models.LOGIN_FAILED_OPERATION) {
                    placeHolder.html(`Login failed: ${event.data.message} (Remote address: ${event.data.remoteAddress})`);
                    iconPlaceHolder.html('person_outline');
                } else if (event.operation === Models.LOCKED_BLOCK_OPERATION) {
                    placeHolder.html(`<i>${event.data.name}</i> locked from Matrix room.<br/>
                                    Comment: ${!Common.Utils.exists(event.data.lockedComment) ? '<i>no comment</i>' :
                                                                                                event.data.lockedComment}`);
                    iconPlaceHolder.html('lock_outline');
                } else if (event.operation === Models.UNLOCKED_BLOCK_OPERATION) {
                    placeHolder.html(`<i>${event.data.name}</i> unlocked from Matrix room.<br/>`);
                    iconPlaceHolder.html('lock_open');
                } else if (event.operation === Models.ADVANCED_SETTINGS_LOAD_OPERATION) {
                    let nodeName: string = "Unknown";
                    let node: NetworkNode = this.nodes[event.data.networkNodeHref];
                    if (node !== undefined) {
                        nodeName = node.name;
                    }
                    placeHolder.html(`User accessed advanced settings for <i>${nodeName}</i> from stream details view.`);
                    iconPlaceHolder.html('settings');
                } else if (event.operation === Models.ADMIN_SETTINGS_LOAD_OPERATION) {
                    let nodeName: string = "Unknown";
                    let node: NetworkNode = this.nodes[event.data.networkNodeHref];
                    if (node !== undefined) {
                        nodeName = node.name;
                    }
                    placeHolder.html(`User accessed admin settings for <i>${nodeName}</i> from stream details view.`);
                    iconPlaceHolder.html('settings');
                } else if (event.operation === Models.VIDEO_PLAY_OPERATION) {
                    let blockName: string = "Unknown";
                    let block: Block = this.blocks[event.data.blockId];
                    if (block !== undefined) {
                        blockName = block.name;
                    }
                    placeHolder.html(`Playing video stream from <i>${blockName}</i> (${event.data.videoUrl}).`);
                    iconPlaceHolder.html('play_arrow');
                } else if (event.operation === Models.VIDEO_PLAY_ATTEMPT_OPERATION) {
                    let blockName: string = "Unknown";
                    let block: Block = this.blocks[event.data.blockId];
                    if (block !== undefined) {
                        blockName = block.name;
                    }
                    placeHolder.html(`Attempt to play video stream from <i>${blockName}</i> (${event.data.videoUrl}).`);
                    iconPlaceHolder.html('play_circle_filled');
                } else if (event.operation === Models.VIDEO_PLAY_ERROR_OPERATION) {
                    let blockName: string = "Unknown";
                    let block: Block = this.blocks[event.data.blockId];
                    if (block !== undefined) {
                        blockName = block.name;
                    }
                    placeHolder.html(`Error playing video stream from <i>${blockName}</i> (${event.data.videoUrl}).`);
                    iconPlaceHolder.html('play_circle_outline');
                }

            // connRoom events
            } else if (event.component === Models.CONNECTION_ROOM_COMPONENT) {
                if (event.operation === Models.CREATE_MONITOR_OPERATION) {
                    placeHolder.html(`Created monitor "${event.data.name}" (id: ${event.data.id}).`);
                    iconPlaceHolder.html('tv');
                } else if (event.operation === Models.DELETE_MONITOR_OPERATION) {
                    placeHolder.html(`Deleted monitor (id: ${event.data.id}).`);
                    iconPlaceHolder.html('tv').css('color', 'red');
                } else if (event.operation === Models.SAVE_MONITOR_OPERATION) {
                    placeHolder.html(`Modified monitor "${event.data.name}" (id: ${event.data.id}).`);
                    iconPlaceHolder.html('tv');
                } else if (event.operation === Models.TRENDING_ON_OPERATION) {
                    placeHolder.html(`Showing trending graph in monitor/multiviewer room "${event.data.name}"`);
                    iconPlaceHolder.html('show_chart');
                } else if (event.operation === Models.TRENDING_OFF_OPERATION) {
                    placeHolder.html(`Hidding trending graph in monitor/multiviewer room "${event.data.name}"`);
                    iconPlaceHolder.html('show_chart');
                }

            // alarms events
            } else if (event.component === Models.ALARMS_COMPONENT) {
                let description: string;
                if (event.operation === Models.BULK_CONFIRM_OPERATION) {

                    let srcElement: string, dstElement: string, isSrcBlock: boolean, isDstBlock: boolean;

                    if (event.data.sourceHref.indexOf('blocks/') > -1) {
                        let element: Block = this.blocks[Common.Utils.strIdFromHref(event.data.destHref)];
                        srcElement = element ? element.name : undefined;
                        isSrcBlock = true;
                    } else {
                        let element: NetworkNode = this.nodes[Common.Utils.strIdFromHref(event.data.destHref)];
                        srcElement = element ? element.name : undefined;
                        isSrcBlock = false;
                    }

                    if (event.data.destHref.indexOf('blocks/') > -1) {
                        let element: Block = this.blocks[Common.Utils.strIdFromHref(event.data.destHref)];
                        dstElement = element ? element.name : undefined;
                        isDstBlock = true;
                    } else {
                        let element: NetworkNode = this.nodes[Common.Utils.strIdFromHref(event.data.destHref)];
                        dstElement = element ? element.name : undefined;
                        isDstBlock = false;
                    }

                    description = `Alarm bulk confirmation for `;
                    if (srcElement && dstElement) {
                        if (isSrcBlock === isDstBlock) {
                            description += `${isSrcBlock ? 'blocks' : 'nodes'} ${srcElement} and ${dstElement}`;
                        } else {
                            description += `${isSrcBlock ? 'block' : 'node'} ${srcElement} and
                                            ${isDstBlock ? 'block' : 'node'} ${dstElement}`;
                        }
                    } else if (srcElement && !dstElement) {
                        description += `${isSrcBlock ? 'block' : 'node'} ${srcElement}`;
                    } else if (!srcElement && dstElement) {
                        description += `${isDstBlock ? 'block' : 'node'} ${dstElement}`;
                    } else {
                        description = '';
                    }

                    iconPlaceHolder.html('notifications_off');
                } else if (event.operation === Models.BULK_CONFIRM_ALL_OPERATION) {
                    description = `Alarm bulk confirmation by admin.`;
                    iconPlaceHolder.html('notifications_off');
                } else if (event.operation === Models.CREATE_ALARM_OPERATION) {
                    let alarmText: string = Models.Alarm.severityTexts[event.data.level];
                    let alarmTextColor: string = event.data.level === 0 || event.data.level === 8 ? 'white' : 'black';
                    let alarmBGColor: string = Models.Alarm.severityColors[event.data.level];
                    description = `
                        <span style="background-color: ${alarmBGColor}; color: ${alarmTextColor}" class="uk-badge">
                            ${alarmText}
                        </span> `;
                    if (event.data.name === 'status') {
                        description += `<i>${event.data.deviceName}</i> went ${event.data.lastValue}.`;
                    } else if (event.data.name === 'inputErrorRate') {
                        description += `<i>${event.data.deviceName}</i> input IP error rate equals to ${event.data.lastValue}.`;
                    } else if (event.data.name === 'missingPackets') {
                        description += `<i>${event.data.deviceName}</i> number of missing input
                                        IP packets equals to ${event.data.lastValue}.`;
                    } else if (event.data.name === 'outputErrorRate') {
                        description += `<i>${event.data.deviceName}</i> ouput IP error rate equals to ${event.data.lastValue}.`;
                    } else if (event.data.name === 'jitter') {
                        description += `<i>${event.data.deviceName}</i> jitter equals to ${event.data.lastValue}.`;
                    } else if (event.data.name === 'bitrate') {
                        description += `<i>${event.data.deviceName}</i> TS input stream bitrate ${event.data.lastValue}.`;
                    } else if (event.data.name === 'streamStatus') {
                        description += `<i>${event.data.deviceName}</i> stream status went ${event.data.lastValue}.`;
                    } else if (event.data.name === 'tsLocked') {
                        description += `<i>${event.data.deviceName}</i> IP transport stream locked went ${event.data.lastValue}.`;
                    } else {
                        description += `<i>${event.data.deviceName}</i> ${event.data.name} (reason: ${event.data.reason}).`;
                    }
                    iconPlaceHolder.html('notifications');
                }
                placeHolder.html(description);

            // networkNodes events
            } else if (event.component === Models.NETWORK_NODES_COMPONENT) {
                if (event.operation === Models.CREATE_NETWORK_NODE_OPERATION) {
                    placeHolder.html(`Created network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}).`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                }  // support legacy create event operations
                else if (event.operation === 'create' && event.data.elementClass === 'gateway') {
                    placeHolder.html(`Created gateway <i>${event.data.name}</i>.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway');
                } else if (event.operation === 'create' && event.data.elementClass === 'networkNode') {
                    placeHolder.html(`Created network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}).`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                } else if (event.operation === Models.CREATE_GATEWAY_OPERATION) {
                    placeHolder.html(`Created gateway <i>${event.data.name}</i>.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway');
                } else if (event.operation === Models.CREATE_NETWORK_OPERATION) {
                    placeHolder.html(`Created network <i>${event.data.name}</i>.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-network');
                } else if (event.operation === Models.DELETE_NETWORK_NODE_OPERATION) {
                    placeHolder.html(`Deleted network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}).`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node').css('color', 'red');                    
                } else if (event.operation === Models.DELETE_GATEWAY_OPERATION) {
                    placeHolder.html(`Deleted gateway <i>${event.data.name}</i>.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway').css('color', 'red');
                } else if (event.operation === Models.CREATE_PROBE_OPERATION) {
                    placeHolder.html(`Created probe <i>${event.data.name}</i>.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-radio-waves');
                } // support legaccy delete event operations
                else if (event.operation === 'delete' && event.data.elementClass === 'gateway') {
                    placeHolder.html(`Deleted gateway <i>${event.data.name}</i>.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway').css('color', 'red');
                } else if (event.operation === 'delete' && event.data.elementClass === 'networkNode') {
                    placeHolder.html(`Deleted network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}).`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node').css('color', 'red');
                } else if (event.operation === Models.DELETE_NETWORK_OPERATION) {
                    placeHolder.html(`Deleted network <i>${event.data.name}</i>.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-network').css('color', 'red');
                } else if (event.operation === Models.SAVE_NETWORK_NODE_OPERATION) {
                    placeHolder.html(`Network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}) has been modified.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                } else if (event.operation === Models.SAVE_GATEWAY_OPERATION) {
                    placeHolder.html(`Gateway <i>${event.data.name}</i> has been modified.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway');
                }  else if (event.operation === Models.DELETE_PROBE_OPERATION) {
                    placeHolder.html(`Deleted probe <i>${event.data.name}</i>.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-radio-waves').css('color', 'red');
                } // support legaccy save event operations
                else if (event.operation === 'save' && event.data.elementClass === 'networkNode') {
                    placeHolder.html(`Network node <i>${event.data.name}</i> (S/N: ${event.data.mftSerialNumber}) has been modified.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                } else if (event.operation === 'save' && event.data.elementClass === 'gateway') {
                    placeHolder.html(`Gateway <i>${event.data.name}</i> has been modified.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-gateway');
                } else if (event.operation === 'save' && event.data.flexo === true) {
                    placeHolder.html(`FlexO has been modified.`);
                    iconPlaceHolder.html('warning');
                } else if (event.operation === Models.SAVE_NETWORK_OPERATION) {
                    placeHolder.html(`Network <i>${event.data.name}</i> has been modified.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-network');
                } else if (event.operation === Models.START_SUPPORT_TEST_OPERATION) {
                    let nodeName: string = "Unknown";
                    let node: NetworkNode = this.nodes[event.data.id];
                    if (node !== undefined) {
                        nodeName = node.name;
                    }
                    placeHolder.html(`Started support toolkit analysis for <i>${nodeName}</i>.`);
                    iconPlaceHolder.html('build');
                } else if (event.operation === Models.END_SUPPORT_TEST_OPERATION) {
                    let nodeName: string = "Unknown";
                    let node: NetworkNode = this.nodes[event.data.id];
                    if (node !== undefined) {
                        nodeName = node.name;
                    }
                    $(`#event-${event.id}-details-button`).css('display', 'block');
                    $(`#event-${event.id}-details-content`).html(event.data.summary);
                    placeHolder.html(`Ended support toolkit analysis for <i>${nodeName}</i>.`);
                    iconPlaceHolder.html('build');
                } else if (event.operation === Models.CREATE_LINK_OPERATION || event.operation === Models.DELETE_LINK_OPERATION) {
                    let srcName: string = event.data.networkElement.name;
                    let srcIp: string = event.data.networkInterface.ipAddress;
                    let dstName: string = event.data.networkInterface.networkConnectedTo.name;
                    let dstIp: string = event.data.networkInterface.networkConnectedTo.ipAddress;
                    let operation: string = event.operation === 'createdLink' ? 'created' : 'deleted';
                    placeHolder.html(`
                        Link ${operation} between <i>${srcName}</i>${srcIp !== '' ? ` (${srcIp})` : ''}
                        and <i>${dstName}</i>${dstIp !== '' ? ` (${dstIp})` : ''}.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-link');
                    if (event.operation === 'deletedLink') iconPlaceHolder.css('color', 'red');
                } else if (event.operation === Models.WORKFLOW_CHANGED_OPERATION) {
                    placeHolder.html(`Network node <i>${event.data.name}</i> (S/N: ` + 
                                     `${event.data.mftSerialNumber}) set to workflow mode: ` + 
                                     `<b>${event.data.workflowMode}</b>`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-node');
                } else if (event.operation === Models.DEVICE_CREDENTIALS_CHANGED) {
                    placeHolder.html(`Credentials changed for device ${event.data.deviceName}`);
                    iconPlaceHolder.html('lock').css('color', 'red');
                } else if (event.operation === Models.SAVE_PROBE_OPERATION) {
                    placeHolder.html(`Probe <i>${event.data.name}</i> has been modified.`);
                    iconPlaceHolder.removeClass('material-icon').addClass('eurovision-icon eurovision-radio-waves');
                } else if (event.operation === Models.NETWORK_NODE_ORGANIZATION_CHANGED_OPERATION) {
                    placeHolder.html(`Device <i>${event.data.name}<i> moved to organization <i>
                        ${this.vnos[event.data.organizationId].name}<i>.`);
                    iconPlaceHolder.html('location_city');
                } else if (event.operation === Models.NETWORK_NODE_ORGANIZATION_ADDED_OPERATION) {
                    placeHolder.html(`<i>Device ${event.data.name}<i> added to organization <i>
                    ${this.vnos[event.data.organizationId].name}<i>.`);
                    iconPlaceHolder.html('location_city');
                } else if (event.operation === Models.NETWORK_NODE_ORGANIZATION_REMOVED_OPERATION) {
                    placeHolder.html(`<i>Device ${event.data.name}<i> removed from organization <i>
                        ${this.vnos[event.data.organizationId].name}<i>.`);
                    iconPlaceHolder.html('location_city');
                } else if (event.operation === Models.NETWORK_ORGANIZATION_ADDED_OPERATION) {
                    placeHolder.html(`<i>Network ${event.data.name}<i> added to organization <i>
                        ${this.vnos[event.data.organizationId].name}<i>.`);
                    iconPlaceHolder.html('location_city');
                } else if (event.operation === Models.NETWORK_ORGANIZATION_REMOVED_OPERATION) {
                    placeHolder.html(`<i>Network ${event.data.name}<i> removed from organization <i>
                        ${this.vnos[event.data.organizationId].name}<i>.`);
                    iconPlaceHolder.html('location_city');
                } else if (event.operation === Models.GATEWAY_ORGANIZATION_ADDED_OPERATION) {
                    placeHolder.html(`Gateway <i>${event.data.name}<i> added to organization <i>
                        ${this.vnos[event.data.organizationId].name}<i>.`);
                    iconPlaceHolder.html('location_city');
                } else if (event.operation === Models.GATEWAY_ORGANIZATION_REMOVED_OPERATION) {
                    placeHolder.html(`Gateway <i>${event.data.name}<i> removed from organization <i>
                        ${this.vnos[event.data.organizationId].name}<i>.`);
                    iconPlaceHolder.html('location_city');
                }

            // watchdog events
            } else if (event.component === Models.WATCHDOG_COMPONENT) {
                if (event.operation === Models.SERVICE_UP_OPERATION) {
                    placeHolder.html(`Service ${event.data.service} up.`);
                    iconPlaceHolder.html('warning');
                } else if (event.operation === Models.SERVICE_DOWN_OPERATION) {
                    placeHolder.html(`Service ${event.data.service} down.`);
                    iconPlaceHolder.html('warning').css('color', 'red');
                }
            // flex-auth events
            } else if (event.component === Models.FLEXAUTH_COMPONENT) {
                if (event.operation === Models.USER_CREATED_OPERATION) {
                    if (event.data.username !== undefined)
                        placeHolder.html(`User ${event.data.username} created by ${event.userId}.`);
                    else
                        placeHolder.html(`User created by ${event.userId}.`); 
                    iconPlaceHolder.html('person');
                }
                else if (event.operation === Models.USER_SAVED_OPERATION) {
                    if (event.data.toggled) {
                        if (event.data.enabled)
                            placeHolder.html(`User ${event.data.username} enabled by ${event.userId}.`);
                        else
                            placeHolder.html(`User ${event.data.username} disabled by ${event.userId}.`);
                    } else {
                        placeHolder.html(`User ${event.data.username} modified by ${event.userId}.`);
                    }
                    iconPlaceHolder.html('person');
                }
                else if (event.operation === Models.GROUP_CREATED_OPERATION) {
                    placeHolder.html(`Group ${event.data.groupname} created by ${event.userId}.`);
                    iconPlaceHolder.html('person');
                }
                else if (event.operation === Models.GROUP_SAVED_OPERATION) {
                    placeHolder.html(`Group ${event.data.groupname} modified by ${event.userId}.`);
                    iconPlaceHolder.html('person');
                }
                else if (event.operation === Models.GROUP_DELETED_OPERATION) {
                    placeHolder.html(`Group ${event.data.groupname} deleted by ${event.userId}.`);
                    iconPlaceHolder.html('person');
                }
                else if (event.operation === Models.USER_ADDED_TO_GROUP) {
                    placeHolder.html(`User ${event.data.username} added to group ${event.data.groupname} by ${event.userId}.`);
                    iconPlaceHolder.html('group');
                }
                else if (event.operation === Models.USER_REMOVED_FROM_GROUP) {
                    placeHolder.html(`User ${event.data.username} removed from group ${event.data.groupname} by ${event.userId}.`);
                    iconPlaceHolder.html('group');
                }
                else if (event.operation === Models.USER_ADDED_TO_ROLE) {
                    if (event.data.rolename !== undefined) {
                        placeHolder.html(`User ${event.data.username} added to role ${event.data.rolename} by ${event.userId}.`);
                        iconPlaceHolder.html('person');
                    }
                }
                else if (event.operation === Models.USER_REMOVED_FROM_ROLE) {
                    placeHolder.html(`User ${event.data.username} removed from role ${event.data.rolename} by ${event.userId}.`);
                    iconPlaceHolder.html('person');
                }
                else if (event.operation === Models.OPERATION_CREATE_ORGANIZATION) {
                    placeHolder.html(`Organization ${event.data.name} created.`);
                    iconPlaceHolder.html('location_city');
                }
                else if (event.operation === Models.OPERATION_SAVE_ORGANIZATION) {
                    placeHolder.html(`Organization ${event.data.name} edited.`);
                    iconPlaceHolder.html('location_city');
                }
                else if (event.operation === Models.OPERATION_DELETE_ORGANIZATION) {
                    placeHolder.html(`Organization ${event.data.name} created.`);
                    iconPlaceHolder.html('location_city');
                }
                else if (event.operation === Models.USER_REMOVED_FROM_ORGANIZATION) {
                    placeHolder.html(`User ${event.data.username} removed from organization ${event.data.orgname}.`);
                    iconPlaceHolder.html('group');
                }
            }
        }

        private unbindEvents: () => void = () => {
            let eventsToUnbind: JQuery = $('.event-to-unbind');
            if (eventsToUnbind.length > 0) {
                eventsToUnbind.unbind('click');
            }
            angular.element(this.$window).unbind('scroll');
        };
    }

    interface IOffsettedRepo {
        page: number;
        totalLoaded: number;
        pendingElements: number;
        firstLoadFinished: boolean;
        loading: boolean;
    }
}
